
const SolnaOverlay = () => {
    return (
        <article className="solna-overlay">
            <p className="overlay-text">Den ursprungliga Forca Fighting-klubben i vars lokaler barn och vuxna, nybörjare och proffs har drillats i en mängd olika kampsporter. Dessa lokaler har också format våra stjärnor som har dragit in titlar efter titlar.<br/> Två pass om dagen, fem dagar i veckan. Barnträning en gång varje vecka.</p>
        </article>
    );
};

export default SolnaOverlay;